var map = {
	"./arunkumar.webp": 40483,
	"./balashanthi.webp": 72350,
	"./charanya.webp": 38448,
	"./gayathri.webp": 90670,
	"./gurugokul.webp": 65050,
	"./harini.webp": 66146,
	"./jayadharshini.webp": 16380,
	"./kalaivani.webp": 15557,
	"./kannan.webp": 14434,
	"./karthikeyan.webp": 52828,
	"./kayalvili.webp": 19899,
	"./keerthika.webp": 98853,
	"./latha.webp": 69337,
	"./logeshwaran.webp": 75036,
	"./mohanaarasi.webp": 76191,
	"./natesan.webp": 72099,
	"./pragatheeswari.webp": 88152,
	"./preethisri.webp": 79456,
	"./priyanka.webp": 70278,
	"./ramya.webp": 87445,
	"./renugadevi.webp": 18507,
	"./sathya.webp": 24507,
	"./senthilvadivu.webp": 89863,
	"./shangavi.webp": 25912,
	"./sri_kiruthika.webp": 7268,
	"./subapriya.webp": 62487,
	"./subhasree.webp": 12781,
	"./thangamani.webp": 9341,
	"./vigneshwaran.webp": 68348,
	"./vimaladevi.webp": 11343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95815;